<template>
  <div class="sales-fab" :class="{ 'sales-fab--open': menuOpen }">
    <div v-if="menuOpen" class="sales-fab__menu" role="menu">
      <p class="sales-fab__hint">{{ salesContacts.specialistHint }}</p>
      <a
        v-if="salesContacts.telegramUrl"
        :href="salesContacts.telegramUrl"
        class="sales-fab__item"
        target="_blank"
        rel="noopener noreferrer"
        @click="onContact('telegram')"
      >
        <i class="fa-brands fa-telegram" aria-hidden="true" /> Telegram
      </a>
      <a
        v-if="salesContacts.phoneTel"
        :href="`tel:${salesContacts.phoneTel}`"
        class="sales-fab__item"
        @click="onContact('phone')"
      >
        <i class="fa-solid fa-phone" aria-hidden="true" /> {{ salesContacts.phoneDisplay }}
      </a>
      <a
        v-if="salesContacts.email"
        :href="`mailto:${salesContacts.email}`"
        class="sales-fab__item"
        @click="onContact('email')"
      >
        <i class="fa-regular fa-envelope" aria-hidden="true" /> E-mail
      </a>
      <button type="button" class="sales-fab__item sales-fab__item--btn" @click="onAskQuestion">
        <i class="fa-regular fa-comment-dots" aria-hidden="true" /> Задать вопрос
      </button>
    </div>
    <button
      type="button"
      class="sales-fab__toggle"
      :aria-expanded="menuOpen"
      aria-label="Связаться со специалистом"
      @click="toggleMenu"
    >
      <i class="fa-regular fa-comments" aria-hidden="true" />
      <span class="sales-fab__label">Связаться со специалистом</span>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { salesContacts } from '@/config/salesContacts'
import { trackSalesMetrikaGoal } from '@/utils/metrikaGoals'

const emit = defineEmits(['open-quiz'])
const router = useRouter()
const menuOpen = ref(false)

function toggleMenu() {
  menuOpen.value = !menuOpen.value
}

function onContact() {
  trackSalesMetrikaGoal('contact_click')
  menuOpen.value = false
}

function onAskQuestion() {
  trackSalesMetrikaGoal('demo_request')
  menuOpen.value = false
  emit('open-quiz')
  if (router.currentRoute.value.path !== '/') {
    router.push({ path: '/', query: { funnel: 'open' } })
  }
}
</script>

<style scoped>
.sales-fab {
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  z-index: 1040;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
}

.sales-fab__menu {
  background: #fff;
  border: 1px solid #d2dbe8;
  border-radius: 14px;
  padding: 0.75rem;
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.12);
  min-width: 16rem;
  max-width: 18rem;
}

.sales-fab__hint {
  margin: 0 0 0.5rem;
  font-size: 0.78rem;
  color: #516078;
  line-height: 1.4;
}

.sales-fab__item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.55rem 0.65rem;
  border-radius: 10px;
  color: #0f172a;
  text-decoration: none;
  font-size: 0.9rem;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.sales-fab__item:hover {
  background: #eaf1ff;
}

.sales-fab__toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 1rem;
  border-radius: 999px;
  border: none;
  background: linear-gradient(135deg, #0071e3 0%, #004494 100%);
  color: #fff;
  font-weight: 700;
  font-size: 0.85rem;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(0, 113, 227, 0.35);
}

.sales-fab__label {
  max-width: 11rem;
  line-height: 1.2;
  text-align: left;
}

@media (max-width: 480px) {
  .sales-fab__label {
    display: none;
  }

  .sales-fab__toggle {
    width: 3rem;
    height: 3rem;
    padding: 0;
    justify-content: center;
    border-radius: 50%;
  }
}
</style>
